import layoutColors from "@shared/styles/layout/colors/layoutColors.js"
import StyleGuide from "@shared/style-guide"

class ColorsConfig {
  constructor() {
    const providerColors = StyleGuide.getConfigsColorsAndLogos()

    this.primary = providerColors.colors.primary
    this.secondary = providerColors.colors.secondary
    this.blueGrey = layoutColors.blueGrey
    this.grey = layoutColors.grey
    this.neutral = layoutColors.neutral
    this.semantic = layoutColors.semantic
    this.support = layoutColors.support
    this.indicators = layoutColors.indicators
    this.gradientRedGreen = layoutColors.gradientRedGreen
    this.services = layoutColors.services
    this["status-info"] = layoutColors["status-info"]
    this["map-legend"] = layoutColors["map-legend"]
  }

  pick(type, weight) {
    return this[type][weight] ? this[type][weight] : "#000000"
  }
}

export default ColorsConfig
